// extracted by mini-css-extract-plugin
export default {"over-view":"review_over-view__NtKUP","header-left":"review_header-left__CpOLm","header-right":"review_header-right__6BbbO","review":"review_review__C7Ekn"};